export default "__VITE_ASSET__C9T8T1hX__"